function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import './header.scss';
import AOS from 'aos';
export default /*#__PURE__*/_asyncToGenerator(function* () {
  // Header toggle
  $('.header__toggle').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.header__menu').toggleClass('header__menu--open');
    $('body').toggleClass('scroll-hidden');
  });
  AOS.init({
    once: 'true'
  });

  // Add event listener on keypress tab
  $(document).on('keydown', function (e) {
    if (e.which == 9) {
      let toggleEl = document.querySelector('.header__toggle');
      if (!toggleEl || !toggleEl.classList.contains('is-active')) {
        return;
      }
      let navEl = document.querySelector('nav');
      let focusableEls = navEl.querySelectorAll('a[href]:not([disabled])');
      let [firstFocusableEl] = focusableEls;
      let lastFocusableEl = focusableEls[focusableEls.length - 1];
      if (e.shiftKey) /* Shift + tab */{
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* Tab */{
          // Console.log( document.activeElement );
          // Console.log( lastFocusableEl );

          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
    }
  });
});